import * as React from 'react';
import * as classnames from 'classnames/bind';
import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';

const styles = require('./WSPButton.less');
const cx = classnames.bind(styles);

export enum ButtonStyle
{
    Raised = 1,
    Simple = 2,
    SimpleSecondary = 3
}

export enum ButtonSize
{
    Small = 1,          // 24
    Medium = 2,         // 32
    Default = 3,        // 36
    Large = 4,          // 40
    ExtraLarge = 5,     // 48
}

const styleSuffixes =
{
    [ButtonStyle.Raised]:          'raisedStyle',
    [ButtonStyle.Simple]:          'simpleStyle',
    [ButtonStyle.SimpleSecondary]: 'simpleSecondaryStyle',
};

const sizeSuffixes =
{
    [ButtonSize.Small]:      'smallSize',
    [ButtonSize.Medium]:     'mediumSize',
    [ButtonSize.Default]:    'defaultSize',
    [ButtonSize.Large]:      'largeSize',
    [ButtonSize.ExtraLarge]: 'extraLargeSize',
};

const intentSuffixes =
{
    [MDIntent.Default]: 'defaultIntent',
    [MDIntent.Success]: 'successIntent',
    [MDIntent.Warning]: 'warningIntent',
    [MDIntent.Danger]:  'dangerIntent',
};

export interface ButtonProps
{
    id?:string;
    caption?:string;
    icon?: string|React.ReactElement<any>;
    iconSize?: MDIconSize;
    onClick?:(e:React.SyntheticEvent<any>)=>(void);
    onMouseDown?:(e:React.SyntheticEvent<any>)=>(void);
    className?:string;
    iconClassName?:string;
    style?:ButtonStyle;
    size?:ButtonSize;
    intent?:MDIntent;
    isIntentStyleDisabled?:boolean;
    isDisabled?:boolean;
    isLoading?:boolean;
}

export class WSPButton extends React.Component<ButtonProps, any>
{
    render()
    {
        let {id, className, iconClassName, icon, iconSize, caption, style, size, intent, isIntentStyleDisabled, isDisabled, isLoading} = this.props;

        let maybeId = {};
        if( id )
            maybeId = {id: id};

        if( !style )
            style = ButtonStyle.Raised;

        if( !size )
            size = ButtonSize.Default;

        if( !iconSize )
            iconSize = MDIconSize.medium;

        if( !intent )
            intent = MDIntent.Default;

        let styleSuffix = styleSuffixes[style];

        let sizeSuffix = sizeSuffixes[size];

        let intentSuffix = intentSuffixes[intent];
        let intentObj: any = {};
        intentObj[intentSuffix] = !isIntentStyleDisabled;

        let hasIconId = icon && typeof icon === 'string';
        let hasIconElement = icon && typeof icon !== 'string';
        let hasCaption = caption?true:false;
        let isIconOnly = hasIconId && !hasCaption;
        let hasIconClassName = iconClassName?true:false;

        return  <button {...maybeId}
                        type="button"
                        className={cx('button',
                                      className,
                                    styleSuffix,
                                    sizeSuffix,
                                    intentObj,
                                    {isDisabled: isDisabled || isLoading},
                                    {isNotDisabled: !isDisabled},
        )}
                        onClick={this.props.onClick}
                        onMouseDown={this.props.onMouseDown}
                        disabled={isDisabled || isLoading}
        >
            {
                hasIconId?
                    <MDIcon name={icon as string}
                            size={iconSize}
                            className={cx(  iconClassName,
                                        {'icon':!hasIconClassName},
                                        {iconRightMarginNo: isIconOnly},
                                        {iconRightMarginYes: !isIconOnly}
                                )}/>
                    :
                    hasIconElement?
                        icon
                        :
                        null
            }

            {hasCaption? this.props.caption : null}
            {this.props.children}

        </button>;
    }
}
